import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Topbar from '../../components/Topbar';
import Sidebar from '../../components/Sidebar';
import FloatingFeedbackButton from '../../components/FloatingFeedbackButton';
import { 
  toggleSidebar, 
  toggleMobileSidebar,
  setMobileSidebarState
} from '../../store/sidebarSlice';
import './AdminLayout.scss';

const AdminLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { isCollapsed, mobileOpen } = useSelector(state => state.sidebar);

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleToggleMobileSidebar = () => {
    dispatch(toggleMobileSidebar());
  };

  const handleCloseMobileSidebar = () => {
    dispatch(setMobileSidebarState(false));
  };

  return (
    <div className={`admin-layout ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Topbar 
        onToggleSidebar={handleToggleSidebar}
        onToggleMobileSidebar={handleToggleMobileSidebar}
        isSidebarCollapsed={isCollapsed}
      />
      <div className="layout-container">
        <Sidebar 
          isCollapsed={isCollapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={handleCloseMobileSidebar}
        />
        <main className="content">
          <div className="content-wrapper">
            {children}
          </div>
        </main>
      </div>
      
      {/* Floating Feedback Button - appears on all pages */}
      <FloatingFeedbackButton />
    </div>
  );
};

export default AdminLayout; 